import React from "react";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import BreadcrumbsTemp from "../../components/UI/BreadCrumb/BreadCrumbCustom";
import { Grid } from "@material-ui/core";
import { withRouter } from "react-router";
import { client } from "../../service/ApolloClient/ApolloClient";
import { ErrorToast } from "../../hoc/ToastNotify/ToastNotify";
import { QUERY_LEGAL_ENTITY } from "../../service/ApolloClient/ApolloQueries";
import LegalEntityListAttachment from "./LegalEntityListAttachment";
import LegalEntityAddForm from "../../components/LegalEntity/Add/LegalEntityAddForm";

export const LEGAL_ENTITY_SELECT_EDIT = "LEGAL_ENTITY_SELECT_EDIT";
export const CAR_CONTRACT_SELECT_ATTACHMENT = "CAR_CONTRACT_SELECT_ATTACHMENT";

class LegalEntityEditPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      id: props.match.params.id,
      data: null,
      loading: true,
      pageSelect: LEGAL_ENTITY_SELECT_EDIT,
    };

    this.handleSelectPage = this.handleSelectPage.bind(this);
    this.loadPage = this.loadPage.bind(this);
  }

  componentDidMount() {
    this.loadPage();
  }

  componentDidUpdate(prevProps) {
    const id = this.props.match.params.id;
    if (id !== prevProps.match.params.id) {
      this.setState(
        {
          id,
          data: null,
          loading: true,
          pageSelect: LEGAL_ENTITY_SELECT_EDIT,
        },
        () => this.loadPage(id),
      );
    }
  }

  loadPage(id = this.state.id) {
    this.setState({
      loading: true,
    });

    client
      .query({
        query: QUERY_LEGAL_ENTITY,
        variables: {
          id: parseInt(id),
        },
        fetchPolicy: "network-only",
      })
      .then((res) => {
        if (String(this.props.match.params.id) !== String(id)) return;
        let data = res.data.legalEntity;

        this.setState({
          loading: false,
          data: data,
        });
      })
      .catch((err) => {
        if (String(this.props.match.params.id) !== String(id)) return;
        this.setState({
          loading: false,
          data: null,
        });
        ErrorToast("مشکل در دریافت اطلاعات");
      });
  }

  handleSelectPage(page) {
    this.setState({
      pageSelect: page,
    });
  }

  render() {
    const { loading, data, pageSelect } = this.state;

    let componentSelect = <Wrapper>در حال بارگزاری</Wrapper>;

    if (pageSelect === LEGAL_ENTITY_SELECT_EDIT) {
      componentSelect = (
        <LegalEntityAddForm
          handleSelectPage={this.handleSelectPage}
          data={data}
          isEdit={true}
        />
      );
    } else if (pageSelect === CAR_CONTRACT_SELECT_ATTACHMENT) {
      componentSelect = (
        <LegalEntityListAttachment
          carContract={data}
          handleBack={() => {
            this.handleSelectPage(LEGAL_ENTITY_SELECT_EDIT);
          }}
        />
      );
    }

    return (
      <Wrapper>
        <BreadcrumbsTemp
          items={[
            {
              title: "ویرایش فرد حقوقی ",
              to: "/legal-entity/edit",
            },
          ]}
        />

        <Grid container={true}>
          <Grid item xs={12}>
            {loading ? (
              <Wrapper>در حال بارگزاری</Wrapper>
            ) : data === null ? (
              <Wrapper>اطلاعاتی برای نمایش نیست</Wrapper>
            ) : (
              componentSelect
            )}
          </Grid>
        </Grid>
      </Wrapper>
    );
  }
}

export default withRouter(LegalEntityEditPage);
